export default __webpack_public_path__ + "static/blur-indigo-d33b8ab33fdfc7fab00ffd095977bf32.png";